import React, { Component } from 'react';
import { connect } from 'react-redux';
// with withRouter You can get access to the history object’s properties
import { withRouter } from 'react-router-dom';
import { getUser } from '../actions/userAction';
import Loading from '../components/Loading';

class LoadingComponent extends Component {
    componentWillMount() {
        const { userLoading } = this.props;
        // if we havent tried to load the user, load user
        if (userLoading === undefined) {
            this.props.getUser();
        }
    }

    componentWillReceiveProps(nextProps) {

    }

    render() {
        const { userLoading, children } = this.props;
        
        if ((!userLoading) || this.props.user === null || !this.props.user.userProfileLoaded) {
            return <div>{children}</div>;
        } else {
            return <Loading fullHeight={true}/>;
        }
    }
}

function mapStateToProps(state) {
    return {
        userLoading: state.loading.user,
        user: state.user
    };
}

export default withRouter(connect(mapStateToProps, { getUser })(LoadingComponent));



// WEBPACK FOOTER //
// ./src/components/LoadingComponent.js